import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popup } from "../../../../library/popup";
import {
  changeClientsModal,
  requestUpdateSingleClient,
  resetActiveClientDisplay,
} from "../../../../../redux/actions/clients";
import EditCompanyView from "./company-details-container";
import EditPersonView from "./person-details-container";
import { TransparentButton, SolidButton } from "../../../../library/button";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const modalState = useSelector((state) => state.clients.showModals.editModal);
  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const activeClient = useSelector((state) => state.clients.activeClient);

  const updateLoading = useSelector(
    (state) => state.clients.updateClient.loading
  );

  const [companyObject, setCompanyObject] = useState({
    type: "company",
    logoUrl: null,
    general: {
      name: null,
      organizationNumber: null,
      industry: null,
      employees: null,
      parentCompany: null,
      established: null,
      shareCapital: null,
      roles: [],
      shareholders: [],
    },
    financials: {
      creditRating: {
        date: null,
        description: null,
        rating: null,
      },
    },
    address: {
      street: null,
      postalCode: null,
      city: null,
      coordinates: null,
      county: null,
      municipality: null,
      region: null,
    },
    contact: {
      phone: "",
      email: null,
      website: null,
    },
    social: {
      twitter: null,
      facebook: null,
    },
  });

  const [personObject, setPersonObject] = useState({
    type: "person",
    logoUrl: null,
    general: {
      firstName: null,
      lastName: null,
    },
    contact: {
      phone: "",
      email: null,
      website: null,
    },
    social: {
      twitter: null,
      facebook: null,
    },
    address: {
      street: null,
      postalCode: null,
      city: null,
    },
  });

  const handleClose = () => {
    dispatch(changeClientsModal({ editModal: false }));
    dispatch(resetActiveClientDisplay());
  };

  const clickUpdateClient = () => {
    if (activeClient && activeClient.type === "person") {
      dispatch(
        requestUpdateSingleClient({
          client: personObject,
          clientId: activeClient.id,
          companyId: `${companyId}`,
          type: activeClient.type,
        })
      );
    } else {
      dispatch(
        requestUpdateSingleClient({
          client: companyObject,
          clientId: activeClient.id,
          companyId: `${companyId}`,
          type: activeClient.type,
        })
      );
    }
  };

  useEffect(() => {
    if (Object.keys(activeClient).length > 0) {
      if (activeClient && activeClient.type === "person") {
        setPersonObject(activeClient.client);
      } else if (activeClient && activeClient.type === "company") {
        setCompanyObject(activeClient.client);
      }
    }
  }, [activeClient]);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Rediger kunde"
      buttons={[
        <TransparentButton
          title="Avbryt"
          id="closeButtonEdit"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={updateLoading ? "Oppdaterer.." : "Oppdater"}
          icon={
            updateLoading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-sync"></i>
            )
          }
          onClick={() => clickUpdateClient()}
          type="button"
        />,
      ]}
    >
      <div className="edit-client-content-container">
        {activeClient && activeClient.type === "person" ? (
          <EditPersonView
            personObject={personObject}
            setPersonObject={setPersonObject}
          />
        ) : (
          <EditCompanyView
            companyObject={companyObject}
            setCompanyObject={setCompanyObject}
          />
        )}
      </div>
    </Popup>
  );
};

export default Index;
